import { providers } from '../../providers';
import { kie } from '../kie';
import { wavespeed } from '../wavespeed';
import type { TersaImageModel } from '../types';

// 系数
const COST_FACTOR = 1.5;

export const xaiModels: Record<string, TersaImageModel> = {
    'grok-imagine-image-2.0': {
        // 通用兜底默认（优先级 1）：无 international 标签的用户看不到 seedream 国际版（default: 2）时用它。
        default: true,
        chef: providers.xai,
        providers: [
            {
                ...providers.xai,
                model: undefined,
                model_create: kie.image('grok-imagine-image-2.0'),
                modelBackup_create: [wavespeed.image('x-ai/grok-imagine-image-v2.0/text-to-image')],
                model_edit: kie.image('grok-imagine-image-2.0'),
                modelBackup_edit: [wavespeed.image('x-ai/grok-imagine-image-v2.0/edit')],
                getCost: ({ mode } = {}) => {
                    if (mode === 'i2i') return 0.06 * COST_FACTOR;
                    return 0.05 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['1x1', '16x9', '9x16', '3x2', '2x3'],
                resolutions: ['2K', '1K'],
            },
            i2i: {
                sizes: ['match', '1x1', '16x9', '9x16', '3x2', '2x3'],
                resolutions: ['2K', '1K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 5, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};